<template>
  <div>
    <h2 class="d-flex justify-center title">Specs Matrix</h2>
    <v-row>
      <v-col sm="3">
        <v-autocomplete
          :items="domains"
          v-model="selected_domain_one"
          item-value="id"
          item-text="domain"
          label="First Domain"
          @change="search_categories(true)"
        ></v-autocomplete>
      </v-col>
      <v-col sm="3" offset="1">
        <v-autocomplete
          :items="domains"
          v-model="selected_domain_two"
          item-value="id"
          item-text="domain"
          label="Second Domain"
          @change="search_categories(false)"
        ></v-autocomplete>
      </v-col>
      <v-col sm="2" offset="1">
        <div class="d-flex flex-column">
          <div class="d-flex justify-start">
            <v-btn
              class="mx-2"
              color="primary"
              @click="fetchDomainSpecs"
              :disabled="specs_loader"
              :loading="specs_loader"
            >load specs</v-btn>
            <v-btn
              color="red darken-1"
              class="mx-2"
              @click="reset_all"
            >RESET ALL</v-btn>
          </div>
          <div class="d-flex justify-start my-1">
            <v-btn
              class="mx-2"
              color="warning darken-1"
              :disabled="!selected_spec_one || !selected_spec_two"
              @click="empty_selections"
            >
              empty specs
            </v-btn>

            <v-btn
              class="mx-2"
              color="primary"
              :disabled="!selected_spec_one || !selected_spec_two"
              @click="prepare_connect_specs_dialog"
            >
              connect specs
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4">
        <v-autocomplete
          :disabled="!(!!selected_domain_one && categories_one.length)"
          :items="categories_one"
          v-model="selected_category_one"
          label="Categories"
          :loading="categories_one_loader"
          multiple
          dense
          clearable
        >
          <template v-slot:selection="">
            <span ></span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col sm="4" offset="1">
         <v-autocomplete
          :disabled="!(!!selected_domain_two && categories_two.length)"
          :items="categories_two"
          v-model="selected_category_two"
          label="Categories"
          :loading="categories_two_loader"
          multiple
          dense
          clearable
        >
        <template v-slot:selection="">
          <span ></span>
        </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4" >
        <span>{{ first_domain_name }}</span>
      </v-col>
      <v-col sm="4" >
        <span>{{ second_domain_name }}</span>
      </v-col>
      <v-col sm="4" >
        <span>INFORDER SPECS</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="2" offset="1" class="pb-0">
        <v-text-field
          v-model="search_one"
          outlined
          :loading="search_loader_one"
          label="search specs"
        ></v-text-field>
      </v-col>
      <v-col sm="2" offset="2" class="pb-0">
        <v-text-field
          v-model="search_two"
          outlined
          :loading="search_loader_two"
          label="search specs"
        ></v-text-field>
      </v-col>
      <v-col sm="2" offset="2" class="pb-0">
        <v-text-field
          v-model="search_merged_specs"
          outlined
          :loading="search_loader_merged"
          label="search merged specs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col sm="4">
        <v-virtual-scroll
          :bench="0"
          :items="filtered_specs_one"
          height="500"
          item-height="64"
          v-model="selected_spec_one"
          multiple
        >
          <template v-slot:default="{ item }">
            <v-list-item :value="item" @click="vmodel_sync(item, true)" :input-value="sync_spec_one.includes(item)">
              <template v-slot:default="{ active }">
                <v-list-item-content>
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-virtual-scroll>
        <!-- <v-list v-show="!!specs_one.length" class="overflow-auto">
          <v-list-item-group
            v-model="selected_spec_one"
            active-class="pink--text"
            multiple
            shaped
          >
            <template v-for="(item, index) in filtered_specs_one" >
              <v-list-item :key="index" :value="item" @click="vmodel_sync(item, true)">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list> -->
      </v-col>
      <v-col sm="4">
        <v-virtual-scroll
          :bench="0"
          :items="filtered_specs_two"
          height="500"
          item-height="64"
        >
          <template v-slot:default="{ item }">
            <v-list-item :value="item" @click="vmodel_sync(item, false)" :input-value="sync_spec_two.includes(item)">
              <template v-slot:default="{ active }">
                <v-list-item-content>
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-col>
      <v-col sm="4">

        <v-virtual-scroll
          :items="filtered_merged_specs"
          :item-height="50"
          height="500"
        >
          <template v-slot:default="{ item, idx }">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item.title + ' - ' + item.items.length }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  depressed
                  small
                  @click.stop="prepare_delete_whole_spec(item, idx)"
                >
                  View Specs

                  <v-icon
                    color="orange darken-4"
                    right
                  >
                    mdi-open-in-new
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>

        <!-- <v-virtual-scroll
          :bench="0"
          :items="filtered_merged_specs"
          height="500"
          item-height="64"
        >
          <template v-slot:default="{ item }">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <span>{{ item.title + ' - ' + item.items.length }}</span>
                  <v-btn :block="true" small text color="red" @click.stop="prepare_delete_whole_spec(item, idx)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list-item
                    v-for="child in item.items"
                    :key="child.title"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="child.title"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-virtual-scroll> -->
        <!-- ------------------- -->
        <!-- <v-list v-show="!!merged_items.length">
          <v-list-group
            v-for="(item, idx) in filtered_merged_specs"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title + ' - ' + item.items.length"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn fab small text color="red" @click.stop="prepare_delete_whole_spec(item, idx)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </template>

            <v-list-item
              v-for="child in item.items"
              :key="child.title"
            >
              <v-list-item-content>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list> -->
      </v-col>
    </v-row>
    <v-dialog
      v-model="specs_loader"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="connect_specs_dialog.show"
      width="800"
    >
      <v-card>
        <v-card-text>
          <v-container class="mt-5">
            <v-combobox
              v-model="merge_spec_title"
              :search-input.sync="merge_spec_title_sync"
              :items="available_specs"
              label="spec name"
              outlined
              :loading="merge_spec_loader"
            ></v-combobox>
          </v-container>
          <div>
            <v-row>
              <v-col v-for="(col, i) in available_domain_slots" :key="i">
                <span class="white--text headline text-decoration-underline mb-5" v-if="connect_specs_dialog.show">
                  {{ domains.find( d => d.id === ((i === 0) ? selected_domain_one : selected_domain_two)).domain }}
                </span>
                <ul class="mt-2" v-for="(spec, spec_i) in col" :key="spec_i">
                  <li>{{ spec }}</li>
                </ul>
              </v-col>
            </v-row>
          </div>

        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-btn @click="connect_specs_dialog.show = false">cancel</v-btn>
          <v-btn @click="connect_specs">merge specs</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="delete_spec_dialog.show"
      width="800"
    >
      <v-card>
        <v-card-title>Check the spec - '{{ delete_spec_dialog.item.title }}'</v-card-title>
        <v-card-text>
          <ul class="mt-2" v-for="(spec, spec_i) in delete_spec_dialog.item.items" :key="spec_i">
            <li>
              {{ domains.find(d => d.id === spec.domain_id).domain + ' - ' + spec.title }}
              <v-btn @click="delete_spec(spec, spec_i)" fab small text color="red"><v-icon>delete</v-icon></v-btn>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios'
import JwtService from '@/assets/js/JwtService'
import { AnalyticsUrl } from '@/assets/js/variables'

export default {
  name: 'specs-matrix-view',
  data: () => ({
    domains: [],
    selected_domain_one: null,
    selected_domain_two: null,
    categories_one: [],
    categories_two: [],
    selected_category_one: [],
    selected_category_two: [],
    categories_one_loader: false,
    categories_two_loader: false,
    specs_one: [],
    specs_two: [],
    selected_spec_one: [],
    selected_spec_two: [],
    sync_spec_one: [],
    sync_spec_two: [],
    specs_loader: false,
    search_one: '',
    search_two: '',
    search_merged_specs: '',
    search_loader_one: false,
    search_loader_two: false,
    search_loader_merged: false,
    debounceTimer: null,
    connect_specs_dialog: {
      show: false,
    },
    merge_spec_title: '',
    saved_specs: [],
    merged_items: [],
    available_specs: [],
    merge_spec_title_sync: '',
    merge_spec_loader: false,
    delete_spec_dialog: {
      show: false,
      item: '',
      loader: false,
      main_spec_index: -1,
    }
  }),
  computed: {
    first_domain_name () {
      return this.remove_leftovers((this.selected_domain_one) ? this.domains.find(d => d.id === this.selected_domain_one).domain : '').toUpperCase()
    },
    second_domain_name () {
      return this.remove_leftovers((this.selected_domain_two) ? this.domains.find(d => d.id === this.selected_domain_two).domain : '').toUpperCase()
    },
    filtered_specs_one () {
      return (!!this.search_one) ? this.specs_one.filter(s => s.toLowerCase().includes(this.search_one.toLowerCase())) : this.specs_one
      // return (!!this.search_one) ? this.specs_one.filter(s => s.includes(this.search_one)) : this.specs_one
    },
    filtered_specs_two () {
      return (!!this.search_two) ? this.specs_two.filter(s => s.toLowerCase().includes(this.search_two.toLowerCase())) : this.specs_two

      // return (!!this.search_two) ? this.specs_two.filter(s => s.includes(this.search_two)) : this.specs_two
    },
    filtered_merged_specs () {
      return (!!this.search_merged_specs) ? this.merged_items.filter(s => s.title.includes(this.search_merged_specs)) : this.merged_items
    },
    available_domain_slots () {
      const res = [];
      if(!!this.selected_spec_one.length) res.push(this.selected_spec_one)
      if(!!this.selected_spec_two.length) res.push(this.selected_spec_two)
      return res;
    },
  },
  mounted () {
    this.getDomains()
  },
  methods: {
    async getDomains () {
      console.log('getDomains - called')
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = { task: 'loadDomains' }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        this.domains = data.domains
      } catch (error) {
        console.log(error)
      }
    },
    async fetchDomainSpecs () {
      // reset
      this.empty_selections();
      this.merged_items = [];
      this.specs_one = [];
      this.specs_two = [];
      //  this.merged_items .push()
      // {
      //     title: this.merge_spec_title,
      //     items: [ { title: spec_name, team: 2, domain_id: this.selected_doamin_two } ],
      //     action: 'circle'
      //   }
      console.log('fetchDomainSpecs - called')
      this.specs_loader = true
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = { task: 'fetch_domain_specs', payload: {
        domains: {
          selected_domain_one: this.selected_domain_one,
          categories_one: this.selected_category_one,
          selected_domain_two: this.selected_domain_two,
          categories_two: this.selected_category_two,
          }
        }
      }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('data', data )
        this.specs_one = data.specs_one
        this.specs_two = data.specs_two
        this.merged_items = data.existing_specs.map(spec => ({
          title: spec.spec_title,
          items: spec.specs.map(s => ({
            title: s.spec_name,
            domain_id: s.domain_id,
            team:(this.selected_domain_one === s.domain_id) ? 1 : 2,
            })),
          action: 'circle'
        }))
        this.specs_loader = false
      } catch (error) {
        console.log(error)
        this.specs_loader = false
      }
    },
    async search_categories ( isFirstDomain ) {
      console.log('search categories called')
      if(isFirstDomain){
        this.categories_one = []
        this.categories_one_loader = true
      } else {
        this.categories_two = []
        this.categories_two_loader = true
      }
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = {
        task: 'fetch_categories',
        payload: { domain_id: (isFirstDomain) ? this.selected_domain_one : this.selected_domain_two }
      }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('fetch_categories data', data )
        if(isFirstDomain){
          this.categories_one = data.categories
          this.categories_one_loader = false
        } else {
          this.categories_two = data.categories
          this.categories_two_loader = false
        }
      } catch (error) {}
    },
    prepare_connect_specs_dialog () {
      this.selected_spec_one = this.sync_spec_one
      this.selected_spec_two = this.sync_spec_two
      this.connect_specs_dialog.show = true
    },
    async connect_specs () {
      (!this.merge_spec_title.length) && (this.merge_spec_title = this.merge_spec_title_sync)
      const first_spec = structuredClone(this.selected_spec_one)
      const second_spec = structuredClone(this.selected_spec_two)
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = {
        task: 'merge_specs',
        payload: {
          domain_one: {
            domain_id: this.selected_domain_one,
            specs: this.selected_spec_one,
          },
          domain_two: {
            domain_id: this.selected_domain_two,
            specs: this.selected_spec_two,
          },
          merge_spec_title: this.merge_spec_title,
        }
      }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('merge_specs data', data )
        const merged_spec = {
          title: this.merge_spec_title,
          items: [],
          action: 'circle'
        }
        // first_spec and second_spec are array of strings like ['asgdgag','asdfasf','fedfsf']
        first_spec.forEach(spec_name => {
          const index = this.specs_one.findIndex(i => i === spec_name)
          this.specs_one.splice(index, 1)
          merged_spec.items.push({ title: spec_name, team: 1, domain_id: this.selected_domain_one })
          this.selected_spec_one = this.selected_spec_one.filter(i => i !== index)
        });
        // same for two
        second_spec.forEach(spec_name => {
          const index = this.specs_two.findIndex(i => i === spec_name)
          this.specs_two.splice(index, 1)
          merged_spec.items.push({ title: spec_name, team: 2, domain_id: this.selected_domain_two })
          this.selected_spec_two = this.selected_spec_two.filter(i => i !== index)
        });

        this.merged_items.push(merged_spec)
        this.selected_spec_one = []
        this.selected_spec_two = []
        this.sync_spec_one = []
        this.sync_spec_two = []
        this.merge_spec_title = ''
        this.merge_spec_title_sync = ''
        this.connect_specs_dialog.show = false

      } catch (error) {
        console.log(error)
      }
      return
    },
    async add_specs ( isFirstDomain ) {
      return
      // if remove return then it search for more specs every time you write on search box
      if(isFirstDomain){
        this.search_loader_one = true
      } else {
        this.search_loader_two = true
      }
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = {
        task: 'get_more_specs',
        payload: {
          domain_id: (isFirstDomain) ? this.selected_domain_one : this.selected_domain_two,
          text:  (isFirstDomain) ? this.search_one : this.search_two,
          categories: (isFirstDomain) ? this.selected_category_one : this.selected_category_two,
        }
      }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('get_more_specs data', data )
        if( isFirstDomain ){
          data.specs.forEach(spec => {
            if(!this.specs_one.includes(spec)){
              this.specs_one.push(spec)
            }
          })
        } else {
          data.specs.forEach(spec => {
            if(!this.specs_two.includes(spec)){
              this.specs_two.push(spec)
            }
          })
        }
        if(isFirstDomain){
          this.search_loader_one = false
        } else {
          this.search_loader_two = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    async find_available_specs ( text ) {
      this.merge_spec_loader = true
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const payload = { task: 'find_available_specs', payload: { text } }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('find_available_specs data', data )
        this.available_specs = data.specs
        this.merge_spec_loader = false
      } catch (error) {
        console.log(error)
      }
    },
    vmodel_sync ( item, isOne ) {
      console.log('item', item)
      console.log('isOne', isOne)
      const sync = (isOne) ? this.sync_spec_one : this.sync_spec_two
      const exists = sync.includes(item)
      if(exists) {
        const index = sync.findIndex(i => i === item)
        sync.splice(index, 1)
      } else {
        sync.push(item)
        // sync.sort()
      }
    },
    empty_selections () {
      [
        this.search_one,
        this.search_two,
        this.selected_spec_one,
        this.sync_spec_one,
        this.selected_spec_two,
        this.sync_spec_two
      ] = ['', '', [], [], [], []]
    },
    prepare_delete_whole_spec (item , index) {
      console.log('item', item)
      console.log('index', index)
      this.delete_spec_dialog.show = true
      this.delete_spec_dialog.item = item
      this.delete_spec_dialog.main_spec_index = index
    },
    async delete_spec (item, child_index) {
      this.delete_spec_dialog.loader = true
      const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } };
      const head_index = this.delete_spec_dialog.main_spec_index;
      const head_spec_title = this.merged_items[head_index].title
      const payload = { task: 'delete_spec', payload: { item, head_spec: head_spec_title } }
      try {
        const { data } = await Axios.post(AnalyticsUrl, payload, params)
        console.log('delete_spec data', data )
        this.merged_items[head_index].items.splice(child_index,1)
        if(this.merged_items[head_index].items.length === 0 && head_index !== -1) {
          this.merged_items.splice(head_index, 1)
          this.delete_spec_dialog.main_spec_index = -1 // head_index
          this.reset_delete_spec_dialog()
        }
      } catch (error) {
        console.log(error)
      }
    },
    reset_delete_spec_dialog() {
      Object.assign(this.delete_spec_dialog, {
        show: false,
        item: '',
        loader: false,
        main_spec_index: -1,
      })
    },
    reset_all () {
      [
        this.search_one,
        this.search_two,
        this.search_merged_specs,
        this.merge_spec_title,
        this.categories_one,
        this.categories_two,
        this.selected_category_one,
        this.selected_category_two,
        this.specs_one,
        this.specs_two,
        this.selected_spec_one,
        this.selected_spec_two,
        this.sync_spec_one,
        this.sync_spec_two,
        this.saved_specs,
        this.merged_items,
        this.available_specs,
      ] = ['', '', '', '', [], [], [], [], [], [], [], [], [], [], [], [], [], ]
    },
    remove_leftovers (domain_name) {
      return domain_name
        .replace("https://", "")
        .replace("http://", "")
        .replace("www.", "");
    },
  },
  watch: {
    search_one(newValue, oldValue) {
      if (!!newValue && newValue.length > 1 &&  newValue !== oldValue) {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          // Run your async function here
        this.add_specs(true);
        }, 1000);
        console.log('sync 1')
        this.selected_spec_one = structuredClone(this.sync_spec_one)
      }
    },
    search_two(newValue, oldValue) {
      if (!!newValue && newValue.length > 1 &&  newValue !== oldValue) {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          // Run your async function here
        this.add_specs(false);
        }, 1000);
        console.log('sync 2')
        this.selected_spec_two = structuredClone(this.sync_spec_two)
      }
    },
    merge_spec_title_sync(newValue, oldValue) {
      if (!!newValue && newValue.length > 1 &&  newValue !== oldValue) {
        this.merge_spec_title = this.merge_spec_title_sync;
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          // Run your async function here
        this.find_available_specs(newValue);
        }, 1000);
        console.log('sync 2')
        this.selected_spec_two = structuredClone(this.sync_spec_two)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/SpecsMatrix.vue